/*
 * tekeningen-in-scanner.js
 * ========================
 * Zet de klikbare explosietekeningen in de partscanner, tussen de motorinformatie
 * (.bw-strip) en de onderdelen (.balk / .wrap).
 *
 * Instellingen (optioneel) via window.TEKENINGEN, vóór dit script:
 *   merken   { Yamaha: "<adres>/yamaha/", Mercury: "<adres>/mercury/" }   vaste laag per merk
 *   pagina   "/pages/explosietekening"   tekeningpagina in het thema (anders <merkmap>/tekening.html)
 *   meelezen false = de scanner roept zelf tekeningenInScanner.toon(id, data, merk) aan (thema);
 *            true (standaard, preview) = /parts meelezen via fetch en de Cache API.
 *
 * Het /parts-antwoord gaat naar sessionStorage (partscanner:parts:<engine_model_id>); de
 * tekeningpagina (iframe, ?ingebed=1) gebruikt dat: geen tweede verzoek.
 */
(function () {
  "use strict";
  var CFG = window.TEKENINGEN || {};
  var LOGO = CFG.logo || "https://bouwmeesterwatersport.nl/cdn/shop/files/bouwmeesterwatersport.svg?v=1764778840";
  var BASIS = window.TEKENINGEN_BASIS || (location.origin + "/tekeningen/");   // absoluut: de pagina heeft een <base>
  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  };
  var indexBelofte = null;
  var huidigeMotor = null;

  // ------------------------------------------------------------ /parts meelezen
  // De scanner haalt /parts van het net óf uit zijn eigen Cache API-opslag
  // (bm-scanner-v1, tot 24 uur, na 1 uur op de achtergrond ververst). Beide routes
  // meelezen; in de echte inbouw roept de scanner gewoon tekeningenInScanner.toon(id, data) aan.
  var bewaar = function (id, data) {
    try { sessionStorage.setItem("partscanner:parts:" + id, JSON.stringify({ tijd: Date.now(), data: data })); } catch (e) {}
  };
  var doorgeven = function (id, r) {
    if (!r || !r.ok) return;
    r.clone().json().then(function (data) { bewaar(id, data); toon(id); }).catch(function () {});
  };
  var partsId = function (invoer) {
    var url = typeof invoer === "string" ? invoer : (invoer && invoer.url) || "";
    var m = url.match(/\/parts\/([0-9a-f-]{36})/);
    return m && m[1];
  };
  var origineel = window.fetch;
  if (CFG.meelezen !== false) window.fetch = function (invoer) {
    var belofte = origineel.apply(this, arguments);
    var id = partsId(invoer);
    if (id) belofte.then(function (r) { doorgeven(id, r); }).catch(function () {});
    return belofte;
  };
  if (CFG.meelezen !== false && window.Cache && Cache.prototype.match) {
    var cacheMatch = Cache.prototype.match;
    Cache.prototype.match = function (invoer) {
      var belofte = cacheMatch.apply(this, arguments);
      var id = partsId(invoer);
      if (id) belofte.then(function (r) { doorgeven(id, r); }).catch(function () {});
      return belofte;
    };
  }

  // ------------------------------------------------------------ blok opbouwen
  // Eén map per merk, elk met dezelfde opbouw (instellingen.json, motoren/, catalogi/,
  // tekening.html, motor-laden.js). motor-laden.js: dezelfde laad- en filterregels als de
  // tekeningpagina zelf; het bestand is voor alle merken gelijk.
  var MERKEN = CFG.merken || window.TEKENINGEN_MERKEN || { Yamaha: BASIS + "yamaha/", Mercury: BASIS + "mercury/" };
  function lader() {
    if (!indexBelofte) indexBelofte = new Promise(function (ok, nee) {
      if (window.laadMotor) return ok();
      var s = document.createElement("script");
      s.src = MERKEN[Object.keys(MERKEN)[0]] + "motor-laden.js";
      s.onload = ok; s.onerror = nee;
      document.head.appendChild(s);
    });
    return indexBelofte;
  }

  // Het merk van de motor eerst (de scanner zet ?merk= in het adres); geen tekeningen
  // daar, dan de andere merkmappen (een onbekende motor geeft per merk één 404).
  function merkvolgorde(merk) {
    var gevraagd = (merk || new URLSearchParams(location.search).get("merk") || "").toLowerCase();
    var namen = Object.keys(MERKEN);
    return namen.filter(function (n) { return n.toLowerCase() === gevraagd; })
      .concat(namen.filter(function (n) { return n.toLowerCase() !== gevraagd; }));
  }

  var beurt = 0;      // alleen de laatste aanvraag mag een blok bouwen (de scanner kan /parts kort na elkaar vaker ophalen)
  function toon(engineId, data, merk) {
    if (data) bewaar(engineId, data);
    if (engineId === huidigeMotor) return;
    huidigeMotor = engineId;
    var mijn = ++beurt;
    document.querySelectorAll(".bw-tekeningen").forEach(function (b) { b.remove(); });
    // Plek meteen vrijhouden (lege kaarten) bij een merk met tekeningen: de scanner scrolt direct
    // na de onderdelen; kwam het blok pas daarna, dan schoof alles eronder nog een stuk op.
    var bekend = Object.keys(MERKEN).some(function (n) { return n.toLowerCase() === String(merk || "").toLowerCase(); });
    var strip = document.querySelector(".bw-parts .bw-strip");
    if (bekend && strip) strip.insertAdjacentElement("afterend", skelet());
    var probeer = function (lijst) {
      if (!lijst.length) return Promise.resolve(null);                 // geen tekeningen voor deze motor
      var map = MERKEN[lijst[0]];
      return window.laadMotor(map, engineId).catch(function () { return null; }).then(function (motor) {
        return motor ? { motor: motor, map: map, merk: lijst[0] } : probeer(lijst.slice(1));
      });
    };
    var weg = function () { if (mijn === beurt) document.querySelectorAll(".bw-tekeningen.bwt-skelet").forEach(function (b) { b.remove(); }); };
    // Merk bekend (de scanner geeft het mee): alleen in de map van dat merk kijken; een merk zonder
    // tekeningen vraagt dan niets op. Geen merk (preview): alle merkmappen, gevraagd merk eerst.
    var lijst = merk ? Object.keys(MERKEN).filter(function (n) { return n.toLowerCase() === String(merk).toLowerCase(); })
                     : merkvolgorde();
    lader().then(function () { return probeer(lijst); })
      .then(function (x) { if (x && mijn === beurt) bouw(engineId, x.motor, x.map, x.merk); else weg(); })   // geen tekeningen: plek weer weg
      .catch(weg);
  }

  // Lege kaarten in dezelfde opmaak als het echte blok (zelfde hoogte), tot de tekeningen er zijn.
  function skelet() {
    var sec = document.createElement("section"), kaarten = "";
    sec.className = "bw-tekeningen bwt-skelet";
    sec.setAttribute("aria-busy", "true");
    for (var i = 0; i < 12; i++) {
      kaarten += '<div class="bwt-kaart" aria-hidden="true"><span class="bwt-mini"></span>' +
        '<span class="bwt-naam">&nbsp;</span><span class="bwt-aantal">&nbsp;</span></div>';
    }
    sec.innerHTML = '<div class="bwt-kop"><div><h3>Explosietekeningen</h3><p>Tekeningen laden…</p></div></div>' +
      '<div class="bwt-strook">' + kaarten + '</div>';
    return sec;
  }

  // De tekeningpagina (thema, ?view=explosietekening) één keer ophalen; in een themavoorbeeld
  // het voorbeeldthema meegeven, anders levert Shopify de pagina van het live thema.
  var paginaBelofte = null;
  function paginaHTML() {
    if (!paginaBelofte) {
      var url = CFG.pagina, voorbeeld = new URLSearchParams(location.search).get("preview_theme_id");
      if (voorbeeld) url += (url.indexOf("?") > -1 ? "&" : "?") + "preview_theme_id=" + encodeURIComponent(voorbeeld);
      paginaBelofte = fetch(url, { credentials: "same-origin" }).then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.text();
      });
      paginaBelofte.catch(function () { paginaBelofte = null; });
    }
    return paginaBelofte;
  }

  // Onderkant van de vaste (sticky/fixed) kop bovenaan het scherm, om de tekening daar net onder te zetten.
  function bovenrand() {
    var el = document.elementFromPoint(window.innerWidth / 2, 2), max = 0;
    while (el && el !== document.body && el !== document.documentElement) {
      var pos = getComputedStyle(el).position;
      if (pos === "fixed" || pos === "sticky") {
        var b = el.getBoundingClientRect().bottom;
        if (b > max && b < window.innerHeight / 2) max = b;
      }
      el = el.parentElement;
    }
    return max;
  }

  window.tekeningenInScanner = { toon: toon };
  // Dit script laadt met 'defer'; vroeg de scanner er al om (antwoord uit de Cache API is
  // snel), dan staat de aanvraag in window.tekeningenWacht: de laatste nu alsnog tonen.
  var wacht = window.tekeningenWacht;
  if (wacht && wacht.length) toon.apply(null, wacht[wacht.length - 1]);

  function bouw(engineId, motor, MAP, MERK) {
    var strip = document.querySelector(".bw-parts .bw-strip");
    if (!strip || engineId !== huidigeMotor) return;
    document.querySelectorAll(".bw-tekeningen").forEach(function (b) { b.remove(); });
    var volgorde = [];
    motor.rubrieken.forEach(function (rub) {
      motor.tekeningen.forEach(function (t) { if (t.rubriek === rub) volgorde.push(t); });
    });
    var posities = function (t) { var s = {}; t.onderdelen.forEach(function (r) { s[r.ref] = 1; }); return Object.keys(s).length; };
    var aantalTekst = function (t) {          // lijstgroep: regels tellen (posities zijn daar allemaal '–')
      var n = t.lijst ? t.onderdelen.length : posities(t);
      return n + (n === 1 ? " onderdeel" : " onderdelen");
    };
    // Groep zonder tekening (Mercury: sets, service- en hulpmiddelen): naam, de belangrijkste
    // onderdelen (sets/kits eerst, "(100 Hour)" -> "· 100 uur"), ons logo en de merken
    var AFKORTING = ["HP", "EFI", "DFI", "XD", "NGK", "OEM", "PCM", "ECU", "CDI", "SS", "MFD", "WIF", "LED"];
    var mooi = function (s) {
      var x = String(s || "").trim().replace(/\s*\((\d+)\s*Hours?\)/i, " · $1 uur");
      x = x.split(/\s+/).map(function (w) { return /^[A-Z]{3,}$/.test(w) && AFKORTING.indexOf(w) < 0 ? w.toLowerCase() : w; }).join(" ");
      return x.charAt(0).toUpperCase() + x.slice(1);
    };
    var kernregels = function (t, n) {
      var kit = function (r) { return /\b(KIT|SET)\b/.test(r.naam_oem); };
      var rijen = t.onderdelen.filter(function (r) { return r.naam_oem && !r.nss; });
      var uit = [];
      rijen.filter(kit).concat(rijen.filter(function (r) { return !kit(r); })).some(function (r) {
        var m = mooi(r.naam_oem);
        if (uit.indexOf(m) < 0) uit.push(m);
        return uit.length >= n;
      });
      return uit;
    };
    var mini = function (t) {
      if (t.miniatuur) return '<img loading="lazy" alt="" onerror="this.remove()" src="' + esc(t.miniatuur) + '">';
      return '<span class="bwt-leeg"><img alt="Bouwmeester Watersport" src="' + esc(LOGO) + '">' +   // ons logo bovenaan
        '<b>' + esc(t.naam) + '</b>' +
        '<span class="bwt-kern">' + kernregels(t, 2).map(esc).join("<br>") + '</span>' +
        '<span class="bwt-merken">Mercury · Yamaha · Honda · Suzuki*<br>Quicksilver · Highfield · Cremo · Hollex-Hibo</span>' +
        '<span class="bwt-ster">* Suzuki: onderdelen en service</span></span>';
    };

    var sec = document.createElement("section");
    sec.className = "bw-tekeningen";
    sec.innerHTML =
      '<div class="bwt-kop">' +
        '<div><h3>Explosietekeningen</h3>' +
        '<p>' + volgorde.length + ' tekeningen van deze motor · klik op een tekening en dan op een nummer</p></div>' +
        '<div class="bwt-pijlen"><button type="button" class="bwt-links" aria-label="Naar links">‹</button>' +
        '<button type="button" class="bwt-rechts" aria-label="Naar rechts">›</button></div>' +
      '</div>' +
      '<div class="bwt-strook" role="list">' + volgorde.map(function (t) {
        return '<button type="button" role="listitem" class="bwt-kaart' + (t.rubriek === "Onderhoud & service" ? " bwt-uitgelicht" : "") +
          '" data-fig="' + esc(t.fig) + '">' +
          '<span class="bwt-mini' + (t.miniatuur ? '' : ' bwt-geen') + '">' + mini(t) + '</span>' +
          '<span class="bwt-naam">' + esc(t.naam) + '</span>' +
          '<span class="bwt-aantal">' + aantalTekst(t) + '</span></button>';
      }).join("") + '</div>' +
      '<div class="bwt-viewer" hidden>' +
        '<div class="bwt-viewer-kop"><b class="bwt-titel"></b>' +
        '<button type="button" class="bwt-sluit" aria-label="Tekening sluiten">Sluiten ✕</button></div>' +
        '<iframe class="bwt-frame" title="Explosietekening"></iframe>' +
      '</div>';
    strip.insertAdjacentElement("afterend", sec);

    var strook = sec.querySelector(".bwt-strook"), viewer = sec.querySelector(".bwt-viewer"),
        frame = sec.querySelector(".bwt-frame"), titel = sec.querySelector(".bwt-titel");
    // muiswiel (verticaal) scrolt de strook horizontaal. Aan het begin of eind gaat het
    // wiel gewoon door met de pagina, zodat je nooit vast komt te zitten. Een touchpad
    // dat zelf al horizontaal scrolt, laten we met rust.
    strook.addEventListener("wheel", function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY) || e.ctrlKey) return;
      var max = strook.scrollWidth - strook.clientWidth;
      if (max <= 0) return;
      if ((e.deltaY < 0 && strook.scrollLeft <= 0) || (e.deltaY > 0 && strook.scrollLeft >= max - 1)) return;
      e.preventDefault();
      strook.scrollLeft += e.deltaY * (e.deltaMode === 1 ? 40 : e.deltaMode === 2 ? strook.clientWidth : 1);
    }, { passive: false });
    sec.querySelector(".bwt-links").onclick = function () { strook.scrollBy({ left: -strook.clientWidth * 0.8, behavior: "smooth" }); };
    sec.querySelector(".bwt-rechts").onclick = function () { strook.scrollBy({ left: strook.clientWidth * 0.8, behavior: "smooth" }); };
    sec.querySelector(".bwt-sluit").onclick = function () {
      viewer.hidden = true;
      sec.querySelectorAll(".bwt-kaart.aan").forEach(function (k) { k.classList.remove("aan"); });
    };

    var laatsteFig = null;
    var open = function (fig) {
      var t = motor.tekeningen.filter(function (x) { return x.fig === fig; })[0];
      if (!t) return;
      sec.querySelectorAll(".bwt-kaart").forEach(function (k) { k.classList.toggle("aan", k.dataset.fig === fig); });
      titel.textContent = t.naam;
      laatsteFig = fig;
      if (frame.dataset.motor === engineId) {
        // zelfde motor: alleen wisselen (laadt de pagina nog, dan opent ze straks laatsteFig)
        if (frame.dataset.geladen === engineId) frame.contentWindow.location.hash = "t=" + encodeURIComponent(fig);
      } else if (CFG.pagina) {
        // Winkel: Shopify stuurt X-Frame-Options: DENY mee, dus de tekeningpagina kan niet als
        // adres in het kader. Daarom de pagina zelf ophalen en als inhoud (srcdoc) in het kader
        // zetten: zelfde herkomst, gedeelde sessionStorage, /cart/add.js gewoon bereikbaar.
        frame.dataset.motor = engineId;
        paginaHTML().then(function (html) {
          if (frame.dataset.motor !== engineId) return;
          var params = { ingebed: "1", merk: MERK, motor: engineId, t: laatsteFig };
          frame.srcdoc = html.replace(/<head[^>]*>/i, function (kop) {
            return kop + "<script>window.TEKENING_PARAMS = " + JSON.stringify(params).replace(/</g, "\\u003c") + ";<\/script>";
          });
        }).catch(function () { frame.dataset.motor = ""; });
      } else {
        frame.dataset.motor = engineId;             // los (preview): tekening.html naast de gegevens
        frame.setAttribute("src", MAP + "tekening.html?ingebed=1&merk=" + encodeURIComponent(MERK) +
          "&motor=" + encodeURIComponent(engineId) + "#t=" + encodeURIComponent(fig));
      }
      viewer.hidden = false;
      // Past het vak op het scherm (computer): onderkant van het vak naar de onderkant van het
      // venster, zodat de strook zoveel mogelijk in beeld blijft; staat het al helemaal in beeld,
      // dan niet scrollen. Is het vak hoger dan het scherm (telefoon): bovenkant (titel + tekening)
      // net onder de vaste kop van de winkel, anders kom je bij de onderdelen uit.
      var MARGE = 12, r = viewer.getBoundingClientRect(), kop = bovenrand();
      if (r.height > window.innerHeight - kop - MARGE) {
        window.scrollBy({ top: r.top - kop - MARGE, behavior: "smooth" });
      } else if (r.bottom > window.innerHeight - MARGE) {
        window.scrollBy({ top: r.bottom - window.innerHeight + MARGE, behavior: "smooth" });
      }
    };
    strook.addEventListener("click", function (e) {
      var k = e.target.closest(".bwt-kaart");
      if (k) open(k.dataset.fig);
    });
    // titel van de geopende tekening bijhouden als er binnen de tekening gebladerd wordt
    frame.addEventListener("load", function () {
      frame.dataset.geladen = frame.dataset.motor || "";
      try {
        // intussen een andere tekening gekozen: die tonen
        var nu = new URLSearchParams(frame.contentWindow.location.hash.slice(1)).get("t");
        if (laatsteFig && nu !== laatsteFig) frame.contentWindow.location.hash = "t=" + encodeURIComponent(laatsteFig);
      } catch (e) {}
      try {
        frame.contentWindow.addEventListener("hashchange", function () {
          var f = new URLSearchParams(frame.contentWindow.location.hash.slice(1)).get("t");
          var t = motor.tekeningen.filter(function (x) { return x.fig === f; })[0];
          if (t) {
            titel.textContent = t.naam;
            sec.querySelectorAll(".bwt-kaart").forEach(function (k) { k.classList.toggle("aan", k.dataset.fig === f); });
          }
        });
      } catch (e) {}
    });
    window.tekeningenInScanner.open = open;          // voor de test
    window.tekeningenInScanner.motor = motor;
    // #tekening=31 in het adres: die tekening meteen openen (deeplink, bv. vanaf een onderdeel)
    var gevraagd = new URLSearchParams(location.hash.slice(1)).get("tekening");
    if (gevraagd) open(gevraagd);
  }
})();
